module.exports = __webpack_public_path__ + "img/analysisIcon3.0a052eba.png";